const LBW_NUMERATOR = 9270;

const LBW_FACTORS = {
  Male: {
    DENOM_BASE: 6680,
    BMI_FACTOR: 216,
  },
  Female: {
    DENOM_BASE: 8780,
    BMI_FACTOR: 244,
  },
};

export function calculateLeanBodyWeight({ sex, heightCm, actualBodyWeightKg, precision = 0 }) {
  if (sex !== 'Male' && sex !== 'Female') return null;
  const h = Number(heightCm);
  const w = Number(actualBodyWeightKg);
  if (!isFinite(h) || !isFinite(w) || h <= 0 || w <= 0) return null;
  const factors = LBW_FACTORS[sex];
  const heightM = h / 100;
  const bmi = w / (heightM * heightM);
  if (!isFinite(bmi) || bmi <= 0) return null;
  const lbw = (LBW_NUMERATOR * w) / (factors.DENOM_BASE + factors.BMI_FACTOR * bmi);
  if (!isFinite(lbw) || lbw <= 0) return null;
  
  if (typeof precision === 'number' && precision >= 0) {
    const factor = Math.pow(10, precision);
    return Math.round(lbw * factor) / factor;
  }
  return lbw;
}
